import { Fab } from '@mui/material';
import { WhatsApp as WhasappIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';

const FloatingButton = styled(Fab)<{ $isMobile: boolean; $isTablet: boolean }>(({ theme, $isMobile, $isTablet }) => ({
  position: 'fixed',
  bottom: $isMobile ? '40px' : '40px',
  right: $isMobile ? '20px' : '20px',
  zIndex: 1050,
  width: $isMobile ? '50px' : '60px',
  height: $isMobile ? '50px' : '60px',
  backgroundColor: '#25D366 !important', // !important para sobrescribir estilos de MUI
  color: 'white !important',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
  '&:hover': {
    transform: 'scale(1.1)',
    backgroundColor: '#1da851 !important', // Verde más oscuro para hover
    color: 'white !important'
  },
  '&:focus': {
    backgroundColor: '#25D366 !important',
    color: 'white !important'
  },
  '&:active': {
    backgroundColor: '#1da851 !important',
    color: 'white !important'
  },
  '@media (max-width: 768px)': {
    bottom: '40px',
    right: '15px',
    width: '50px',
    height: '50px'
  },
  '@media (max-width: 480px)': {
    bottom: '40px',
    right: '15px',
    width: '50px',
    height: '50px'
  }
}));

export const FloatingWhatsappButton = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1024px)' });

  const handleClick = () => {
    window.location.href = 'https://wa.link/latwu1';
  };

  return (
    <FloatingButton
      sx={{ backgroundColor: '#25D366', fontSize: '25px' }}
      onClick={handleClick}
      $isMobile={isMobile}
      $isTablet={isTablet}
    >
      <WhasappIcon sx={{ fontSize: isMobile ? '30px' : '40px', color: 'white' }} />
    </FloatingButton>
  );
};
